import React from "react";
import {Link, useNavigate} from "react-router-dom";
import {useGoToSubscription} from "./GoToSubscription";
import {useMediaQuery} from "@mui/material";
import json2mq from "json2mq";
import { tabLink } from "../constant/tablink";

const BottomTab = ({tabsInput, handleLoginClick}) => {
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const goToSubscription = useGoToSubscription();
//  const tabsToRender = tabsInput?.length ? tabsInput : [tabLink["subscription"]];
    const tabsToRender = tabsInput?.length ? tabsInput : [];

    const handleClick = async (e, tab) => {
        if (tab.name === "My Profile" && !userData) {
            e.preventDefault();
            handleLoginClick();
        } else if (tab.name === "My Subscriptions") {
            e.preventDefault();
            await goToSubscription();
        }
    };

    const mediaQueryVar = useMediaQuery(
        json2mq({
            minWidth: 900,
        })
    );

    return (
        <>
            {mediaQueryVar
                ? (<div
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        gap: "10px",
                        margin: "auto auto auto 20px" ,
                    }}
                >
                    {
                        tabsToRender.map((tab, i) => (
                      <Link to={tab.href} key={i} style={{textDecoration: "none"}} onClick={(e) => handleClick(e, tab)}>
                          <div
                              style={{
                                  display: tab.icon ? "flex" : "block",
                                  alignItems: "center",
                                  padding: "8px 5px",
                                  borderRadius: "28px",
                                  background:
                                      "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                                  color: "#1877F2",
                                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 2px 0px 0px rgba(0, 0, 0, 0.20)",
                                  fontWeight: "700",
                                  fontSize: "13px",

                                  cursor: "pointer",
                                  minWidth: "150px",
                                  textAlign: "center",
                                  userSelect: "none",  
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none", 
                              }}
                          >
                              {tab.icon && <img src={tab.icon} alt="icon" style={{marginRight: "5px", height: "15px"}} />}
                              {tab.name}
                          </div>
                      </Link>
                  ))
                    }</div>
                )
                : tabsToRender.map((tab, i) => (
                      <Link to={tab.href} key={i} style={{textDecoration: "none"}} onClick={(e) => handleClick(e, tab)}>
                          <div
                              style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "6px 10px",
                                  borderRadius: "28px",
                                  background:
                                      "linear-gradient(91deg, rgba(154, 255, 249, 0.60) 18.86%, rgba(255, 240, 109, 0.60) 100.02%)",
                                  color: "#1877F2",
                                  boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 2px 0px 0px rgba(0, 0, 0, 0.20)",
                                  fontWeight: "700",
                                  fontSize: "13px",
                                  cursor: "pointer",
                              }}
                          >
                              <img src={tab.icon} alt="icon" style={{marginRight: "5px", height: "15px"}} />
                              {tab.mobile_name}
                          </div>
                      </Link>
                  ))}
        </>
    );
};

export default BottomTab;
